import React from "react";
import './pages.css'

function Footer() {
    return (
        <div className="footer">
            <p style={ { color: "black"}}>
                2024 Vanadium, All Rights Reserved.
            </p>
        </div>
    );
}

export default Footer;
